module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initializationFinished),
      expression: "initializationFinished"
    }]
  }), _c('global-loading'), _c('splash-screen'), _c('sound-manager')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57b91085","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 884
// module chunks = 13